/** This file is auto generated by convertSvgToJsx.ts */

import React from 'react'
const file = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    fill="none"
    viewBox="0 0 16 16"
    {...props}
  >
    <path
      stroke="#000"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M5.5 3.545h2.59M5.5 6H10m-4.5 6.454h3.864m4.454-6.951V14a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1h5.854a1 1 0 0 1 .764.354l2.964 3.503a1 1 0 0 1 .236.646Z"
    />
  </svg>
)
export default file
